<ftr-side-panel-page-layout
  [size]="sidePanelSize.Small"
  name="order"
  [sideBarTemplate]="sideBar"
  [bodyTemplate]="body"
  [loadingTemplate]="loading"
  [emptyTemplate]="empty"
  [entity]="viewModel$"
  [isEmptyFunction]="isEmpty"
  errorMessage="Failed to load the search results. Please try again or contact support@fortherecord.com for advice."
  (onRetry)="retry()"
>
  <ng-template #loading>
    <ftr-line-loader [message]="'Searching for \'' + searchTerm() + '\''"></ftr-line-loader>
  </ng-template>
  <ng-template #empty>
    <ftr-search-results-not-found [searchTerms]="searchTerm()"></ftr-search-results-not-found>
  </ng-template>
  <ng-template #sideBar let-data [ftrTypedContext]="viewModel$">
    @if (data.searchResults.pagination.totalResults) {
      <ftr-search-results-navigation
        [searchTerm]="searchTerm()"
        [numberOfItemsInPage]="data.searchResults.items.length"
        [totalItems]="data.searchResults.pagination.totalResults"
        [offset]="data.searchResults.pagination.offset"
      >
      </ftr-search-results-navigation>
    }
  </ng-template>
  <ng-template #body let-data [ftrTypedContext]="viewModel$">
    <ftr-search-results-list
      [searchResults]="data.searchResults.items"
      [configuration]="data.configuration"
      [searchFocusState]="data.searchFocusState"
      [isSearchWithinResource]="false"
      (onItemSelected)="onItemSelected.emit($event)"
      (onNewSearchFocusState)="onNewSearchFocusState.emit($event)"
    ></ftr-search-results-list>
  </ng-template>
</ftr-side-panel-page-layout>
